<ng-container *transloco="let t">
    <div class="modal-header">
        <h4 class="modal-title">
            {{ title }}
        </h4>
        <button
            type="button"
            class="close"
            (click)="modalService.close()"
            [aria-label]="t('Close button aria label - Close')"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <ul
        ngbNav
        #nav="ngbNav"
        [(activeId)]="active"
        class="nav-tabs mt-1 border-bottom"
    >
        <li [ngbNavItem]="1">
            <button ngbNavLink>
                {{
                    t(
                        "Tab from document (AI template generation modal) - From document"
                    )
                }}
            </button>
            <ng-template ngbNavContent>
                <app-from-document-form
                    #fromDocumentForm
                    (formSubmit)="generateFromDocument($event)"
                >
                </app-from-document-form>
            </ng-template>
        </li>
        <li [ngbNavItem]="2">
            <button ngbNavLink>
                {{
                    t(
                        "Tab from prompt (AI template generation modal) - From prompt"
                    )
                }}
            </button>
            <ng-template ngbNavContent>
                <app-from-scratch-form
                    #fromScratchForm
                    (formSubmit)="generateFromScratch($event)"
                >
                </app-from-scratch-form>
            </ng-template>
        </li>
    </ul>

    <div tabindex="0">
        <div class="modal-body" tabindex="0" ngbAutofocus>
            <i
                class="feather icon-info text-muted generation-info-icon"
                title="{{ modalInfo }}"
            ></i>
            <div [ngbNavOutlet]="nav" class="mt-2"></div>
        </div>
    </div>

    <div class="modal-footer">
        <div>
            <div class="select" *ngIf="showOptions">
                <i class="feather icon-info text-muted"></i>
                <label class="form-label mb-0 text-muted">Purpose</label>
                <select
                    class="form-select"
                    [(ngModel)]="selectedOption"
                    style="max-width: 300px"
                >
                    <option *ngFor="let opt of options" [ngValue]="opt">
                        {{ t(opt.name) }}
                    </option>
                </select>
            </div>
        </div>
        <div>
            <button
                type="button"
                class="btn btn-outline-secondary"
                (click)="modalService.dismiss('Cross click')"
                rippleEffect
            >
                {{ t("Cancel button text (cancel button) - cancel") }}
            </button>
            <button
                [disabled]="!isFormValid"
                class="btn btn-success"
                rippleEffect
                (click)="submitForm()"
            >
                {{ submitButtonTitle }}
            </button>
        </div>
    </div>
</ng-container>
